export default __webpack_public_path__ + "static/media/case-study-center.2566e2e9.png";